import _ from "lodash";
/**--external-- */
import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { Avatar } from "@toddle-edu/ds-web";

import {
  CURRICULUM_TYPE_PYP,
  CURRICULUM_TYPE_MYP,
  CURRICULUM_TYPE_UBD,
  CURRICULUM_TYPE_DP,
} from "Constants/stringConstants";
import { hashString } from "Utils/StringHelpers";
import {
  getOrganizationCurriculumPrograms,
  getAccountCurriculumPrograms,
  getAcademicCurriculumPrograms,
} from "modules/CommonSelectors";

/**--internal-- */
import classes from "./CurriculumProgramLogo.scss";

const FONT_SIZE_TO_HEIGHT_RATIO = 0.3125;

const SIZE_AND_HEIGHT_MAP = {
  large: "44px",
  medium: "36px",
  small: "28px",
  "x-small": "24px",
  "xx-small": "20px",
  "xxx-small": "16px",
};

const SIZE_RADIUS_MAP = {
  "x-large": "10px",
  large: "8px",
  medium: "8px",
  small: "6px",
  "x-small": "4px",
  "xx-small": "4px",
  "xxx-small": "2px",
};

const DEFAULT_ACRONYM_MAP = {
  IB_PYP: "PYP",
  IB_MYP: "MYP",
  UBD: "UBD",
  IB_DP: "DP",
};

const ALLOWED_COLORS_FOR_ACRONYMS = [
  "violet",
  "blue",
  "yellow",
  "pink",
  "teal",
  "purple",
];

const CurriculumProgramLogo = ({ curriculumProgram, size }) => {
  const { type, attachments } = curriculumProgram || {};

  const height = SIZE_AND_HEIGHT_MAP[size] || SIZE_AND_HEIGHT_MAP.medium;
  const borderRadius = SIZE_RADIUS_MAP[size] || SIZE_RADIUS_MAP.medium;
  const acronym = curriculumProgram.acronym || DEFAULT_ACRONYM_MAP[type];

  const url = _.get(attachments, "[0].url");

  /**
   * Set font size based on container height
   */
  const fontSize = Math.floor(parseInt(height) * FONT_SIZE_TO_HEIGHT_RATIO);

  const acronymColor =
    ALLOWED_COLORS_FOR_ACRONYMS[
      hashString(curriculumProgram.id) % ALLOWED_COLORS_FOR_ACRONYMS.length
    ];

  const containerClasses = classNames(
    classes.container,
    {
      [classes.pypContainer]: type == CURRICULUM_TYPE_PYP,
      [classes.mypContainer]: type == CURRICULUM_TYPE_MYP,
      [classes.ubdContainer]: type == CURRICULUM_TYPE_UBD,
      [classes.dpContainer]: type == CURRICULUM_TYPE_DP,
    },
    classes[acronymColor]
  );

  const containerStyle = {
    height: height,
    fontSize,
    minWidth: height,
    borderRadius,
  };

  if (url) {
    return <Avatar shape="square" size={size} src={url} dsVersion="2.0" />;
  }

  return (
    <div className={containerClasses} style={containerStyle} dir="auto">
      {acronym}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const curriculumProgram =
    ownProps.curriculumProgram ||
    _.find(getOrganizationCurriculumPrograms(state), {
      id: ownProps.curriculumProgramId,
    }) ||
    _.find(getAccountCurriculumPrograms(state), {
      id: ownProps.curriculumProgramId,
    }) ||
    _.find(getAcademicCurriculumPrograms(state), {
      id: ownProps.curriculumProgramId,
    });

  return {
    curriculumProgram,
  };
};

export default connect(mapStateToProps)(CurriculumProgramLogo);
